var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{staticClass:"upgrade-modal",attrs:{"size":"small"},on:{"close":function($event){return _vm.$emit('close')}}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center"},[_c('h3',[_vm._v("No More Horses Available")]),_vm._v(" "),_c('div',[_c('router-link',{attrs:{"to":"/account"}},[_vm._v("Upgrade Now")])],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2bb163cc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Horses/Upgrade.vue
// module id = 462
// module chunks = 0